module.exports = __webpack_public_path__ + "1e7db247379bc5ab8fecac3fb2064794.png";